import React, { useEffect, useRef, useState } from "react";
import { FaPlus, FaSearch, FaTh, FaBars, FaSortAmountDown } from "react-icons/fa";
import "./HeaderDrive.scss";

const HeaderDrive = ({
  toggleDropdown,
  dropdownVisible,
  searchQuery,
  handleSearch,
  layout,
  toggleLayout,
  sortColumn,
  toggleSortDirection,
  handleFolderAction,
  handleResultClick,
  searchResults,
  searchRef,
  getFileIcon,
  setGridSize,
  dropdownRef,
}) => {
  const [sizeDropdownVisible, setSizeDropdownVisible] = useState(false);
  const sizeDropdownRef = useRef(null);

  const toggleSizeDropdown = () => setSizeDropdownVisible(!sizeDropdownVisible);
  useEffect(() => {
    function handleClickOutside(event) {
      if (sizeDropdownRef.current && !sizeDropdownRef.current.contains(event.target)) {
        setSizeDropdownVisible(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    // <div className="header">
    <div className={`header ${layout === "grid" ? "grid-layout" : ""}`}>
      <div className="new-folder-btn-wrapper">
        <button className="new-folder-btn" onClick={toggleDropdown}>
          <FaPlus /> New
        </button>

        {dropdownVisible && (
          <div className="dropdown-menu-wrapper" ref={dropdownRef}>
            <div className="dropdown-menu">
              <button onClick={() => handleFolderAction("newFolder")}>New Folder</button>
              <button onClick={() => handleFolderAction("addFile")}>Add File</button>
            </div>
          </div>
        )}
      </div>

      <div className="search-container" ref={searchRef}>
        <div className="search-bar-wrapper">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search in Drive"
            value={searchQuery}
            onChange={handleSearch}
            className="search-bar"
          />
        </div>

        {searchResults.length > 0 && (
          <div className="search-results">
            {searchResults.map((item) => (
              <div key={item._id} className="search-result-item" onClick={() => handleResultClick(item)}>
                {getFileIcon(item.fileUrl, item.name)} {item.name}
                {/* {item.fileUrl ? "📄" : "📁"} {item.name} */}
              </div>
            ))}
          </div>
        )}
      </div>

      {layout === "grid" && (
        <>
          <div className="sort-dropdown">
            <select
              value={sortColumn}
              onChange={(e) => {
                const newSortColumn = e.target.value;
                toggleSortDirection(newSortColumn);
              }}
            >
              <option value="name">Name</option>
              <option value="modified">Last Modified</option>
              <option value="size">File Size</option>
            </select>
          </div>
          <div className="size-selector">
            <button onClick={toggleSizeDropdown}>
             Size
            </button>
            {sizeDropdownVisible && (
              <div className="size-dropdown" ref={sizeDropdownRef}>
                <button
                  onClick={() => {
                    setGridSize("small");
                  }}
                >
                  Small
                </button>

                <button onClick={() => setGridSize("medium")}>Medium</button>
                <button onClick={() => setGridSize("large")}>Large</button>
              </div>
            )}
          </div>
        </>
      )}

      <div className="layout-toggle-btn-wrapper">
        <button
          className={`layout-toggle-btn ${layout === "list" ? "active" : ""}`}
          onClick={() => toggleLayout("list")}
        >
          <FaBars />
        </button>
        <button
          className={`layout-toggle-btn ${layout === "grid" ? "active" : ""}`}
          onClick={() => toggleLayout("grid")}
        >
          <FaTh />
        </button>
      </div>
    </div>
  );
};

export default HeaderDrive;
